import Anchor from "componets/atoms/anchor/anchor";
import Text from "componets/atoms/text/text";
import { useNavigate } from "react-router-dom";
import "../../../styles/fontSizes.scss";
import palette from "../../../styles/palette.scss";
import "./paperworkList.scss";
const PaperworkList = ({ dataMenu }) => {
  const navigateTo = useNavigate();
  return (
    <>
      <div className={`p-work-list__container font-size--2`}>
        {dataMenu.map((paperwork, index) => (
          <div className="p-work-list__card" key={index}>
            <img src={paperwork.img} alt={paperwork.altImg} />
            <br />
            <br />
            <Text type="h" textSize={3}>
              {paperwork.title}
            </Text>
            <br />
            <Text type="p" textSize={2}>
              {paperwork.description}
            </Text>
            <br />
            <Anchor
              color={palette.green}
              onClick={() => navigateTo(paperwork.link)}
              textSize={2}
            >
              {paperwork.descriptionLink}
            </Anchor>
          </div>
        ))}
      </div>
    </>
  );
};

export default PaperworkList;
